import { render } from "./FSelect.vue?vue&type=template&id=60842200"
import script from "./FSelect.vue?vue&type=script&lang=js"
export * from "./FSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__